import { Injectable } from '@angular/core';
import { ApiService } from '../../../core/services/api/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class YoutubeService {
  getYoutubeVideos(): Observable<any> {
    return this.apiService.get<any>('/dashboard/yt_videos');
  }

  constructor(private apiService: ApiService) {}
}
